import React, { useRef } from 'react'
import classNames from 'classnames'
import Icon from '../Icon'

export const Field = React.forwardRef(({
  label,
  description,
  floatingLabel,
  containerProps = {},
  optional = false,
  required = false,
  errors = [],
  element: Component,
  labelClassName,
  descriptionClassName,
  optionalClassName,
  requiredClassName,
  children,
  ...props
}, ref) => {
  const innerRef = ref || React.createRef()

  return (
    <div className="space-y-1 relative" {...containerProps}>
      { (label || description || optional || required) &&
        <div>
          <div className="text-sm font-medium space-x-1 flex">
            { label &&
              <label onClick={() => innerRef.current.focus()} className={classNames(['block', 'text-gray-700'], labelClassName)}>
                { label }
              </label>
            }

            { optional &&
              <span className={classNames(['italic', 'font-normal', 'text-gray-400'], optionalClassName)}>
                Optional
              </span>
            }

            { required &&
              <span className={classNames(['font-normal', 'text-negative'], requiredClassName)}>
                *
              </span>
            }
          </div>
          { description &&
            <div>
              <label className={classNames(['block', 'text-gray-700', 'font-normal', 'text-xs'], descriptionClassName)}>
                { description }
              </label>
            </div>
          }
        </div>
        
      }

      { Component ? (
        <Component innerRef={innerRef} errors={errors} {...props} > 
          { children }
        </Component>
      ) : children }

      { !!errors.length &&
        <div className="text-xs flex items-center space-x-2">
          <Icon icon={['fas', 'warning']} className="text-negative" />

          <div>
            { errors.map((error) => (
              <div className="text-gray-600">{ error }</div>
            )) }
          </div>
        </div>
      }

      { floatingLabel &&
        <div className={classNames([
          'absolute',
          'left-2',
          '-top-2',
          'px-2',
          'font-medium',
          'text-xs',
          'transition-all',
          'transition-duration-200',
          'bg-white',
          'text-gray-400',
        ], {
          'peer-focus:text-primary': !!props.value || !!props.defaultValue || !!innerRef.value?.length,
          'peer-focus:opacity-100': !!props.value || !!props.defaultValue || !!innerRef.value?.length,
          'opacity-100 ': !!props.value || !!props.defaultValue || !!innerRef.value?.length,
          'opacity-0': !props.value || !props.defaultValue || !innerRef.value?.length,
        })}>{ floatingLabel }</div>
      }
    </div>
  )
})

export default Field
